import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _168e5760 = () => interopDefault(import('../pages/applicants/index.vue' /* webpackChunkName: "pages/applicants/index" */))
const _8a2176fc = () => interopDefault(import('../pages/billing/index.vue' /* webpackChunkName: "pages/billing/index" */))
const _9bde5c0e = () => interopDefault(import('../pages/bursaries/index.vue' /* webpackChunkName: "pages/bursaries/index" */))
const _9eeaf8e8 = () => interopDefault(import('../pages/forgot-password/index.vue' /* webpackChunkName: "pages/forgot-password/index" */))
const _03faaff1 = () => interopDefault(import('../pages/head-hunting/index.vue' /* webpackChunkName: "pages/head-hunting/index" */))
const _1a8720fe = () => interopDefault(import('../pages/interviews/index.vue' /* webpackChunkName: "pages/interviews/index" */))
const _0e9ffe90 = () => interopDefault(import('../pages/invite/index.vue' /* webpackChunkName: "pages/invite/index" */))
const _61c8d276 = () => interopDefault(import('../pages/jobs/index.vue' /* webpackChunkName: "pages/jobs/index" */))
const _47667af0 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _e20dbca2 = () => interopDefault(import('../pages/notifications/index.vue' /* webpackChunkName: "pages/notifications/index" */))
const _c8c5b0c6 = () => interopDefault(import('../pages/placements/index.vue' /* webpackChunkName: "pages/placements/index" */))
const _599d706e = () => interopDefault(import('../pages/prospects/index.vue' /* webpackChunkName: "pages/prospects/index" */))
const _6c3a8937 = () => interopDefault(import('../pages/verify-email/index.vue' /* webpackChunkName: "pages/verify-email/index" */))
const _78bb658c = () => interopDefault(import('../pages/account-managers/login.vue' /* webpackChunkName: "pages/account-managers/login" */))
const _bc4a943c = () => interopDefault(import('../pages/billing/statement/index.vue' /* webpackChunkName: "pages/billing/statement/index" */))
const _12f013cb = () => interopDefault(import('../pages/bursaries/draft/index.vue' /* webpackChunkName: "pages/bursaries/draft/index" */))
const _37c9873a = () => interopDefault(import('../pages/company/create.vue' /* webpackChunkName: "pages/company/create" */))
const _27eb3a4a = () => interopDefault(import('../pages/company/profile.vue' /* webpackChunkName: "pages/company/profile" */))
const _c64ff6f0 = () => interopDefault(import('../pages/head-hunting/groups/index.vue' /* webpackChunkName: "pages/head-hunting/groups/index" */))
const _affe3e90 = () => interopDefault(import('../pages/head-hunting/viewed/index.vue' /* webpackChunkName: "pages/head-hunting/viewed/index" */))
const _2d4f0f97 = () => interopDefault(import('../pages/jobs/draft/index.vue' /* webpackChunkName: "pages/jobs/draft/index" */))
const _b312e61a = () => interopDefault(import('../pages/bursaries/draft/_id.vue' /* webpackChunkName: "pages/bursaries/draft/_id" */))
const _03ba0bbf = () => interopDefault(import('../pages/jobs/draft/_id.vue' /* webpackChunkName: "pages/jobs/draft/_id" */))
const _7ecc827b = () => interopDefault(import('../pages/applicants/_name/index.vue' /* webpackChunkName: "pages/applicants/_name/index" */))
const _f2c8e3c6 = () => interopDefault(import('../pages/billing/_name/index.vue' /* webpackChunkName: "pages/billing/_name/index" */))
const _2fce4864 = () => interopDefault(import('../pages/bursaries/_id/index.vue' /* webpackChunkName: "pages/bursaries/_id/index" */))
const _0d0e59aa = () => interopDefault(import('../pages/candidates/_id/index.vue' /* webpackChunkName: "pages/candidates/_id/index" */))
const _67b63ddc = () => interopDefault(import('../pages/interviews/_name/index.vue' /* webpackChunkName: "pages/interviews/_name/index" */))
const _e5dc71a0 = () => interopDefault(import('../pages/jobs/_id/index.vue' /* webpackChunkName: "pages/jobs/_id/index" */))
const _353b5dd4 = () => interopDefault(import('../pages/messages/_name/index.vue' /* webpackChunkName: "pages/messages/_name/index" */))
const _2c5b70f8 = () => interopDefault(import('../pages/placements/_name/index.vue' /* webpackChunkName: "pages/placements/_name/index" */))
const _23e8e770 = () => interopDefault(import('../pages/reset-password/_id.vue' /* webpackChunkName: "pages/reset-password/_id" */))
const _68054f9e = () => interopDefault(import('../pages/bursaries/_id/candidates/index.vue' /* webpackChunkName: "pages/bursaries/_id/candidates/index" */))
const _d132c8e6 = () => interopDefault(import('../pages/candidates/_id/bursaries/index.vue' /* webpackChunkName: "pages/candidates/_id/bursaries/index" */))
const _cc69be9e = () => interopDefault(import('../pages/candidates/_id/jobs/index.vue' /* webpackChunkName: "pages/candidates/_id/jobs/index" */))
const _330d80c4 = () => interopDefault(import('../pages/jobs/_id/advanced-candidate-search/index.vue' /* webpackChunkName: "pages/jobs/_id/advanced-candidate-search/index" */))
const _27cee1e5 = () => interopDefault(import('../pages/jobs/_id/candidates/index.vue' /* webpackChunkName: "pages/jobs/_id/candidates/index" */))
const _54f1e28c = () => interopDefault(import('../pages/bursaries/_id/candidates/_name/index.vue' /* webpackChunkName: "pages/bursaries/_id/candidates/_name/index" */))
const _379a5540 = () => interopDefault(import('../pages/jobs/_id/candidates/_name/index.vue' /* webpackChunkName: "pages/jobs/_id/candidates/_name/index" */))
const _5344be04 = () => interopDefault(import('../pages/messages/_name/_id.vue' /* webpackChunkName: "pages/messages/_name/_id" */))
const _4fe96716 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/applicants",
    component: _168e5760,
    name: "applicants___en"
  }, {
    path: "/af/applicants",
    component: _168e5760,
    name: "applicants___af"
  }, {
    path: "/billing",
    component: _8a2176fc,
    name: "billing___en"
  }, {
    path: "/af/billing",
    component: _8a2176fc,
    name: "billing___af"
  }, {
    path: "/bursaries",
    component: _9bde5c0e,
    name: "bursaries___en"
  }, {
    path: "/af/bursaries",
    component: _9bde5c0e,
    name: "bursaries___af"
  }, {
    path: "/forgot-password",
    component: _9eeaf8e8,
    name: "forgot-password___en"
  }, {
    path: "/af/forgot-password",
    component: _9eeaf8e8,
    name: "forgot-password___af"
  }, {
    path: "/head-hunting",
    component: _03faaff1,
    name: "head-hunting___en"
  }, {
    path: "/af/head-hunting",
    component: _03faaff1,
    name: "head-hunting___af"
  }, {
    path: "/interviews",
    component: _1a8720fe,
    name: "interviews___en"
  }, {
    path: "/af/interviews",
    component: _1a8720fe,
    name: "interviews___af"
  }, {
    path: "/invite",
    component: _0e9ffe90,
    name: "invite___en"
  }, {
    path: "/af/invite",
    component: _0e9ffe90,
    name: "invite___af"
  }, {
    path: "/jobs",
    component: _61c8d276,
    name: "jobs___en"
  }, {
    path: "/af/jobs",
    component: _61c8d276,
    name: "jobs___af"
  }, {
    path: "/login",
    component: _47667af0,
    name: "login___en"
  }, {
    path: "/af/login",
    component: _47667af0,
    name: "login___af"
  }, {
    path: "/notifications",
    component: _e20dbca2,
    name: "notifications___en"
  }, {
    path: "/af/notifications",
    component: _e20dbca2,
    name: "notifications___af"
  }, {
    path: "/placements",
    component: _c8c5b0c6,
    name: "placements___en"
  }, {
    path: "/af/placements",
    component: _c8c5b0c6,
    name: "placements___af"
  }, {
    path: "/prospects",
    component: _599d706e,
    name: "prospects___en"
  }, {
    path: "/af/prospects",
    component: _599d706e,
    name: "prospects___af"
  }, {
    path: "/verify-email",
    component: _6c3a8937,
    name: "verify-email___en"
  }, {
    path: "/af/verify-email",
    component: _6c3a8937,
    name: "verify-email___af"
  }, {
    path: "/account-managers/login",
    component: _78bb658c,
    name: "account-managers-login___en"
  }, {
    path: "/af/account-managers/login",
    component: _78bb658c,
    name: "account-managers-login___af"
  }, {
    path: "/billing/statement",
    component: _bc4a943c,
    name: "billing-statement___en"
  }, {
    path: "/af/billing/statement",
    component: _bc4a943c,
    name: "billing-statement___af"
  }, {
    path: "/bursaries/draft",
    component: _12f013cb,
    name: "bursaries-draft___en"
  }, {
    path: "/af/bursaries/draft",
    component: _12f013cb,
    name: "bursaries-draft___af"
  }, {
    path: "/company/create",
    component: _37c9873a,
    name: "company-create___en"
  }, {
    path: "/af/company/create",
    component: _37c9873a,
    name: "company-create___af"
  }, {
    path: "/company/profile",
    component: _27eb3a4a,
    name: "company-profile___en"
  }, {
    path: "/af/company/profile",
    component: _27eb3a4a,
    name: "company-profile___af"
  }, {
    path: "/head-hunting/groups",
    component: _c64ff6f0,
    name: "head-hunting-groups___en"
  }, {
    path: "/af/head-hunting/groups",
    component: _c64ff6f0,
    name: "head-hunting-groups___af"
  }, {
    path: "/head-hunting/viewed",
    component: _affe3e90,
    name: "head-hunting-viewed___en"
  }, {
    path: "/af/head-hunting/viewed",
    component: _affe3e90,
    name: "head-hunting-viewed___af"
  }, {
    path: "/jobs/draft",
    component: _2d4f0f97,
    name: "jobs-draft___en"
  }, {
    path: "/af/jobs/draft",
    component: _2d4f0f97,
    name: "jobs-draft___af"
  }, {
    path: "/bursaries/draft/:id",
    component: _b312e61a,
    name: "bursaries-draft-id___en"
  }, {
    path: "/af/bursaries/draft/:id",
    component: _b312e61a,
    name: "bursaries-draft-id___af"
  }, {
    path: "/jobs/draft/:id",
    component: _03ba0bbf,
    name: "jobs-draft-id___en"
  }, {
    path: "/af/jobs/draft/:id",
    component: _03ba0bbf,
    name: "jobs-draft-id___af"
  }, {
    path: "/applicants/:name",
    component: _7ecc827b,
    name: "applicants-name___en"
  }, {
    path: "/af/applicants/:name",
    component: _7ecc827b,
    name: "applicants-name___af"
  }, {
    path: "/billing/:name",
    component: _f2c8e3c6,
    name: "billing-name___en"
  }, {
    path: "/af/billing/:name",
    component: _f2c8e3c6,
    name: "billing-name___af"
  }, {
    path: "/bursaries/:id",
    component: _2fce4864,
    name: "bursaries-id___en"
  }, {
    path: "/af/bursaries/:id",
    component: _2fce4864,
    name: "bursaries-id___af"
  }, {
    path: "/candidates/:id",
    component: _0d0e59aa,
    name: "candidates-id___en"
  }, {
    path: "/af/candidates/:id",
    component: _0d0e59aa,
    name: "candidates-id___af"
  }, {
    path: "/interviews/:name",
    component: _67b63ddc,
    name: "interviews-name___en"
  }, {
    path: "/af/interviews/:name",
    component: _67b63ddc,
    name: "interviews-name___af"
  }, {
    path: "/jobs/:id",
    component: _e5dc71a0,
    name: "jobs-id___en"
  }, {
    path: "/af/jobs/:id",
    component: _e5dc71a0,
    name: "jobs-id___af"
  }, {
    path: "/messages/:name",
    component: _353b5dd4,
    name: "messages-name___en"
  }, {
    path: "/af/messages/:name",
    component: _353b5dd4,
    name: "messages-name___af"
  }, {
    path: "/placements/:name",
    component: _2c5b70f8,
    name: "placements-name___en"
  }, {
    path: "/af/placements/:name",
    component: _2c5b70f8,
    name: "placements-name___af"
  }, {
    path: "/reset-password/:id?",
    component: _23e8e770,
    name: "reset-password-id___en"
  }, {
    path: "/af/reset-password/:id?",
    component: _23e8e770,
    name: "reset-password-id___af"
  }, {
    path: "/bursaries/:id/candidates",
    component: _68054f9e,
    name: "bursaries-id-candidates___en"
  }, {
    path: "/af/bursaries/:id/candidates",
    component: _68054f9e,
    name: "bursaries-id-candidates___af"
  }, {
    path: "/candidates/:id?/bursaries",
    component: _d132c8e6,
    name: "candidates-id-bursaries___en"
  }, {
    path: "/af/candidates/:id?/bursaries",
    component: _d132c8e6,
    name: "candidates-id-bursaries___af"
  }, {
    path: "/candidates/:id?/jobs",
    component: _cc69be9e,
    name: "candidates-id-jobs___en"
  }, {
    path: "/af/candidates/:id?/jobs",
    component: _cc69be9e,
    name: "candidates-id-jobs___af"
  }, {
    path: "/jobs/:id/advanced-candidate-search",
    component: _330d80c4,
    name: "jobs-id-advanced-candidate-search___en"
  }, {
    path: "/af/jobs/:id/advanced-candidate-search",
    component: _330d80c4,
    name: "jobs-id-advanced-candidate-search___af"
  }, {
    path: "/jobs/:id/candidates",
    component: _27cee1e5,
    name: "jobs-id-candidates___en"
  }, {
    path: "/af/jobs/:id/candidates",
    component: _27cee1e5,
    name: "jobs-id-candidates___af"
  }, {
    path: "/bursaries/:id/candidates/:name",
    component: _54f1e28c,
    name: "bursaries-id-candidates-name___en"
  }, {
    path: "/af/bursaries/:id/candidates/:name",
    component: _54f1e28c,
    name: "bursaries-id-candidates-name___af"
  }, {
    path: "/jobs/:id/candidates/:name",
    component: _379a5540,
    name: "jobs-id-candidates-name___en"
  }, {
    path: "/af/jobs/:id/candidates/:name",
    component: _379a5540,
    name: "jobs-id-candidates-name___af"
  }, {
    path: "/messages/:name?/:id",
    component: _5344be04,
    name: "messages-name-id___en"
  }, {
    path: "/af/messages/:name?/:id",
    component: _5344be04,
    name: "messages-name-id___af"
  }, {
    path: "/",
    component: _4fe96716,
    name: "index___en"
  }, {
    path: "/af",
    component: _4fe96716,
    name: "index___af"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
